import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/lodging/$bookingId` activates the booking-detail column
// (col 2). The Lodging LAYOUT route (lodging.tsx) reads `$bookingId` from the
// leaf match and renders every column via ColumnLayout. Mirrors forms/$formId.
export const Route = createFileRoute("/$orgSlug/$eventSlug/lodging/$bookingId")({
  component: () => null,
})
